import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon, Loading } from '@ibk/shared-ui';
import styles from './EmptyState.module.css';
export const EmptyState = ({ type, onRequestPermission }) => {
    const { t } = useTranslation();
    const getContent = () => {
        switch (type) {
            case 'loading':
                return {
                    icon: _jsx(Loading, { size: 'small' }),
                    title: t('benefits.network.loading'),
                    message: t('benefits.network.loading.description'),
                    useCircle: true,
                };
            case 'permission-denied':
                return {
                    icon: _jsx(Icon, { name: 'localization' }),
                    title: t('benefits.network.permission.title'),
                    message: t('benefits.network.permission.description'),
                    action: onRequestPermission ? (_jsx("button", { onClick: onRequestPermission, className: styles.feedbackButton, "data-testid": 'network-permission-button', children: t('benefits.network.permission.enable') })) : undefined,
                };
            case 'no-results-location':
                return {
                    icon: _jsx(Icon, { name: 'circleInfo' }),
                    title: t('benefits.network.emptyState.noResultsLocation.title'),
                    message: t('benefits.network.emptyState.noResultsLocation.message'),
                };
            case 'no-results-search':
                return {
                    icon: _jsx(Icon, { name: 'search' }),
                    title: t('benefits.network.emptyState.noResultsSearch.title'),
                    message: t('benefits.network.emptyState.noResultsSearch.message'),
                };
            case 'api-error':
                return {
                    icon: _jsx(Icon, { name: 'circleBlock' }),
                    title: t('benefits.network.emptyState.apiError.title'),
                    message: t('benefits.network.emptyState.apiError.message'),
                };
            default:
                return {
                    icon: _jsx(Icon, { name: 'circleInfo' }),
                    title: '',
                    message: '',
                };
        }
    };
    const content = getContent();
    return (_jsxs("div", { className: styles.emptyState, role: 'status', "aria-live": 'polite', children: [_jsx("div", { className: content.useCircle ? styles.iconWithCircle : styles.icon, children: content.icon }), _jsx("h3", { className: styles.title, children: content.title }), _jsx("p", { className: styles.message, children: content.message }), content.action] }));
};
